module.exports = __webpack_public_path__ + "static/media/food-styling.c5995507.png";